// Добавьте этот скрипт в конец body или в отдельный JS файл
document.addEventListener('DOMContentLoaded', function() {
  const scrollTopButton = document.querySelector('.scroll-top');

  if (!scrollTopButton) return;

  // Функция для показа/скрытия кнопки
  function toggleScrollButton() {
    if (window.scrollY > 500) {
      scrollTopButton.classList.add('scroll-top--visible');
      scrollTopButton.style.display = 'flex';
    } else {
      scrollTopButton.classList.remove('scroll-top--visible');
      scrollTopButton.style.display = 'none';
    }
  }

  // Функция для плавного скролла наверх
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  // Обработчик скролла
  window.addEventListener('scroll', toggleScrollButton);

  // Обработчик клика по кнопке
  scrollTopButton.addEventListener('click', scrollToTop);

  // Инициализация при загрузке
  toggleScrollButton();

  // Добавляем поддержку клавиатуры
  scrollTopButton.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollToTop();
    }
  });

  // Улучшенная версия с дросселингом для оптимизации
  let isThrottled = false;

  window.addEventListener('scroll', function() {
    if (!isThrottled) {
      isThrottled = true;
      toggleScrollButton();

      setTimeout(() => {
        isThrottled = false;
      }, 100);
    }
  });
});
